import { render, staticRenderFns } from "./Sinader.vue?vue&type=template&id=5fac88a9&"
import script from "./Sinader.vue?vue&type=script&lang=js&"
export * from "./Sinader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports